import { Box, Typography } from '@mui/material'
import linkForwardIcon from '../../assets/icons/stories/link-forward.png'
import { BUTTON_TRANSITION } from '../../theme/buttonHover'
import { MOBILE_MQ, mobileSectionLabelSx, mobileSectionTitleSx } from '../../theme/mobileLayout'

export default function StoryDetailHeader({ date, title, onShare }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 3, md: '40px' },
        width: '100%',
        [MOBILE_MQ]: { gap: '24px' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: 2,
          [MOBILE_MQ]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
          },
        }}
      >
        <Typography
          sx={{
            ...mobileSectionLabelSx,
            fontSize: { ...mobileSectionLabelSx.fontSize, md: 24 },
          }}
        >
          {date}
        </Typography>
        <Box
          component="button"
          type="button"
          onClick={onShare}
          aria-label="Share story"
          sx={{
            width: 24,
            height: 24,
            p: 0,
            border: 'none',
            bgcolor: 'transparent',
            cursor: 'pointer',
            flexShrink: 0,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: BUTTON_TRANSITION,
          }}
        >
          <Box
            component="img"
            src={linkForwardIcon}
            alt=""
            sx={{ width: 24, height: 24, display: 'block' }}
          />
        </Box>
      </Box>

      <Typography
        component="h1"
        sx={{
          ...mobileSectionTitleSx,
          width: '100%',
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}
